export default "__VITE_PUBLIC_ASSET__002ffc55__"